export function generateSnapshot(originalLines, entries, indexMapping) {
  // indexMapping: { category: { oldIndex: newIndex, ... }, ... }
  const out = originalLines.slice();
  for (const e of entries) {
    const mapForCat = indexMapping[e.category];
    if (mapForCat && mapForCat.hasOwnProperty(e.index)) {
      const newIndex = mapForCat[e.index];
      const newLine = `${e.category}.${newIndex}.${e.rest}=${e.value}`;
      out[e.lineIndex] = newLine;
    }
  }
  return out.join("\n");
}
